export default {
  he: {
    $vuetify: {
      close: 'Close',
      dataIterator: {
        pageText: '{0}-{1} מתוך {2}',
        noResultsText: 'לא נמצאו תוצאות',
        loadingText: 'טוען פריט...',
      },
      dataTable: {
        itemsPerPageText: 'שורות לעמוד:',
        ariaLabel: {
          sortDescending: ': Sorted descending. Activate to remove sorting.',
          sortAscending: ': Sorted ascending. Activate to sort descending.',
          sortNone: ': Not sorted. Activate to sort ascending.',
        },
      },
      dataFooter: {
        itemsPerPageText: 'פריטים לדף:',
        itemsPerPageAll: 'הכל',
        nextPage: 'עמוד הבא',
        prevPage: 'עמוד הקודם',
        firstPage: 'עמוד ראשון',
        lastPage: 'עמוד אחרון',
      },
      datePicker: {
        itemsSelected: '{0} נבחרו',
      },
      noDataText: 'אין נתונים',
      carousel: {
        prev: 'מצג קודם',
        next: 'מצג הבא',
      },
      calendar: {
        moreEvents: '{0} נוספים',
      },
      fileInput: {
        counter: '{0} קבצים',
        counterSize: '{0} files ({1} in total)',
      },
    }
  }
}